<section class="expand-event-wrap prematch"  [attr.data-sportId]="expandedEventResult.sportId" id="expandEventWrap"
[ngClass]="{'versionV2': viewConfigurations.useMobileViewWithTopMenu}" >
  <div class="event-details box mb-3">
    <div class="close-back" (click)="hideDetails()">
      <i class="icon icon-cross icon-sm"></i>
    </div>
    <div class="match-info">
      <div class="competition-name">{{expandedEventResult.regionName}} {{expandedEventResult.competitionName}}</div>
      <div class="time-info">
        <i class="icon icon-calendar-full"></i> {{expandedEventResult.eventDateTime | date:"dd LLL"}}
        <i class="icon icon-clock"></i> {{expandedEventResult.eventDateTime | date: "HH:mm"}}
      </div>
    </div>
    <div class="teams-info">
      <div class="team">
        <div class="short-name h6">{{expandedEventResult.homeTeamShort}}</div>
        <div class="name">{{expandedEventResult.homeTeam}}</div>
      </div>

      <div class="date-score" *ngIf="expandedEventResult.awayTeam && expandedEventResult.results[2] && expandedEventResult.results[2].scorePeriods[0]">
        <div class="score">{{expandedEventResult.results[2].scorePeriods[0].homeAwayValue[enumsHomeAway.HOME]}} : {{expandedEventResult.results[2].scorePeriods[0].homeAwayValue[enumsHomeAway.AWAY]}}</div>
      </div>

      <div class="team">

        <div class="short-name h6">{{expandedEventResult.awayTeamShort}}</div>
        <div class="name">{{expandedEventResult.awayTeam}}</div>
      </div>
    </div>

    <div class="bet-menu-wrap">
      <ng-container *ngFor="let betTypeGroup of betTypeGroups">
        <div class="bet-menu-item" *ngIf="betTypeGroup.isOnline" [class.active]="betTypeGroup.isSelected"  (click)="selectGroup(betTypeGroup)">{{betTypeGroup.name | lowercase}}</div>
      </ng-container>
    </div>
  </div>

  <section class="bet-types-main-wrap box">
    <div class="bet-types-wrap" *ngIf="selectedBetTypeGroup">
      <ng-container *ngFor="let betTypeGroupingTemplateItem of selectedBetTypeGroup.betTypeGroupingTemplateItems">
        <article class="single-bet-type-wrap" *ngIf="filteredBetsAndBetTypeShowType[betTypeGroupingTemplateItem.betTypeId]">
          <ng-container *ngIf="filteredBetsAndBetTypeShowType[betTypeGroupingTemplateItem.betTypeId]; let betAndBetTypeShowTypeForExpandedEvent;">
            <div class="bet-type-name h6" *ngIf="betAndBetTypeShowTypeForExpandedEvent.betTypeShowType.showType == betTypeNameDispayTypeEnum.BetTypeNameHeaderRow
            && betTypeGroupingTemplateItem.sbvSelectionType == SBVSelectionEnum.All">
              <ng-container *ngIf="expandedEventResult.eventType == eventTypeENUM.HeadToHead">{{betAndBetTypeShowTypeForExpandedEvent.betTypeShowType.betTypeName}}</ng-container>
              <ng-container *ngIf="expandedEventResult.eventType == eventTypeENUM.Outright">{{betAndBetTypeShowTypeForExpandedEvent.betTypeOutrightName}}</ng-container>
              <span class="more-info" *ngIf="viewConfigurations.showBetTypeNameDescription && betAndBetTypeShowTypeForExpandedEvent.betTypeShowType.betTypeDescription">
                <i class="description-icon icon icon-ex-sm s-icon-sporticon-error" (click)="showDescription($event)" (mouseover)="toggleDescription($event)" (mouseout)="toggleDescription($event)"></i>
                <span class="description-title">{{betAndBetTypeShowTypeForExpandedEvent.betTypeShowType.betTypeDescription}}</span>

              </span>

              <!-- <span class="icon cashout">
                <div class="sporticon sporticon-transaction icon-sm" title="Casheback" *ngIf="betAndBetTypeShowTypeForExpandedEvent.bets[0] && betAndBetTypeShowTypeForExpandedEvent.bets[0].cashBackEnabled"></div>
              </span> -->
            </div>
            <div class="bets-conatainer bets-in-row-{{betAndBetTypeShowTypeForExpandedEvent.betTypeShowType.numberOfBetsInRow}}">
              <ng-container *ngFor="let bet of betAndBetTypeShowTypeForExpandedEvent.bets; let i = index;" >
                <div class="single-bet" *ngIf="
                (betTypeGroupingTemplateItem.sbvSelectionType === SBVSelectionEnum.All ||
                (betTypeGroupingTemplateItem.sbvSelectionType === SBVSelectionEnum.MostBalanced && betAndBetTypeShowTypeForExpandedEvent.mostBalancedBetIndex == i) ||
                (betTypeGroupingTemplateItem.sbvSelectionType === SBVSelectionEnum.Exact && bet.sbv === betTypeGroupingTemplateItem.sbvExactValue))">
                  <div class="bet-type-name h6" *ngIf="betAndBetTypeShowTypeForExpandedEvent.betTypeShowType.showType == betTypeNameDispayTypeEnum.BetTypeNameSameRow || betTypeGroupingTemplateItem.sbvSelectionType != SBVSelectionEnum.All">
                    <ng-container *ngIf="expandedEventResult.eventType == eventTypeENUM.HeadToHead">{{betAndBetTypeShowTypeForExpandedEvent.betTypeShowType.betTypeName}}</ng-container>
                    <ng-container *ngIf="expandedEventResult.eventType == eventTypeENUM.Outright">{{bet.outrightName}}</ng-container>
                    <span class="sbv" *ngIf="betAndBetTypeShowTypeForExpandedEvent.betTypeShowType.sbvDisplayType === SBVDisplayTypeEnum.SBVInBetType">
                      <ng-container *ngIf="!bet.useSbvHandicapPipe">{{bet.sbv}}</ng-container>
                      <ng-container *ngIf="bet.useSbvHandicapPipe">{{bet.sbv | handicapSbv}}</ng-container>
                    </span>
                    <span class="more-info" *ngIf="viewConfigurations.showBetTypeNameDescription && betAndBetTypeShowTypeForExpandedEvent.betTypeShowType.betTypeDescription">
                      <i class="description-icon icon icon-ex-sm s-icon-sporticon-error" (click)="showDescription($event)" (mouseover)="toggleDescription($event)" (mouseout)="toggleDescription($event)"></i>
                      <span class="description-title">{{betAndBetTypeShowTypeForExpandedEvent.betTypeShowType.betTypeDescription}}</span>
                    </span>

                    <!-- <span class="icon cashout">
                      <div class="sporticon sporticon-transaction icon-sm" title="Casheback" *ngIf="betAndBetTypeShowTypeForExpandedEvent.bets[0] && betAndBetTypeShowTypeForExpandedEvent.bets[0].cashBackEnabled"></div>
                    </span> -->
                  </div>
                  <div class="bet-outcomes-wrap" [class.two-column]="betAndBetTypeShowTypeForExpandedEvent.betTypeShowType.betTypeOutcomesList.length == 2" [class.single-column]="betAndBetTypeShowTypeForExpandedEvent.betTypeShowType.betTypeOutcomesList.length == 1" >
                    <ng-container *ngFor="let bto of betAndBetTypeShowTypeForExpandedEvent.betTypeShowType.betTypeOutcomesList">
                      <ng-container *ngTemplateOutlet="outcome; context:{bet: bet, betTypeOutcome: bto, betTypeShowType: betAndBetTypeShowTypeForExpandedEvent.betTypeShowType}">
                        </ng-container>
                    </ng-container>
                  </div>
                </div>
              </ng-container>
            </div>
          </ng-container>
        </article>
      </ng-container>
    </div>

    <ng-template #outcome let-bet="bet" let-betTypeOutcome="betTypeOutcome" let-betTypeShowType="betTypeShowType">
          <!-- SBV SEPARATE -->
          <ng-container *ngIf="betTypeShowType.sbvDisplayType == SBVDisplayTypeEnum.SBVAlone; else sbvInBetTypeOrOutcome;">
            <ng-container *ngIf="bet.betOutcomesDic[betTypeOutcome.id] && bet.betOutcomesDic[betTypeOutcome.id].length > 0; else emptyOutcome;">
              <ng-container *ngFor="let betOutcome of bet.betOutcomesDic[betTypeOutcome.id]; let k = index;">
                <div class="outcome-wrap">
                    <div  class="btn small outline-light outcome disabled" [ngClass]="{'selected': betOutcome.resultStatus === outcomeResultStatusEnum.Passed}" title="{{betOutcome.description}}">
                        <span class="outcome-name">{{betOutcome.name}}</span>
                        <span class="odd online-odd" *ngIf="betOutcome.odd > 1">{{betOutcome.odd | odd}}</span>
                    </div>
                </div>
                <div class="sbv-wrap" *ngIf="bet.sbv && betTypeOutcome.orderNumber == 1 && k == 0">
                    <div class="btn small outline-info sbv disabled">
                      <ng-container *ngIf="!bet.useSbvHandicapPipe">{{bet.sbv}}</ng-container>
                      <ng-container *ngIf="bet.useSbvHandicapPipe">{{bet.sbv | handicapSbv}}</ng-container>
                    </div>
                </div>
              </ng-container>
            </ng-container>
            <ng-template #emptyOutcome>
              <div class="outcome-wrap" *ngIf="bet.sbv">
                <div class="btn small outline-light outcome disabled">
                  <span class="outcome-name">{{betTypeOutcome.name}}</span>
                  <i class="icon icon-ex-sm icon-lock"></i>
                </div>
              </div>
              <div class="sbv-wrap" *ngIf="bet.sbv && betTypeOutcome.orderNumber == 1">
                <div class="btn small outline-info sbv disabled">
                  <ng-container *ngIf="!bet.useSbvHandicapPipe">{{bet.sbv}}</ng-container>
                  <ng-container *ngIf="bet.useSbvHandicapPipe">{{bet.sbv | handicapSbv}}</ng-container>
                </div>
              </div>
            </ng-template>
          </ng-container>
          <ng-template #sbvInBetTypeOrOutcome>
            <ng-container  *ngIf="bet.betOutcomesDic[betTypeOutcome.id] && bet.betOutcomesDic[betTypeOutcome.id].length > 0; else emptyOutcome2;">
              <ng-container *ngFor="let betOutcome of bet.betOutcomesDic[betTypeOutcome.id]; let k = index;">
                <div class="outcome-wrap">
                  <div  class="btn small outline-light outcome disabled" title="{{betOutcome.description}}" [ngClass]="{'selected': betOutcome.resultStatus === outcomeResultStatusEnum.Passed}">
                      <span class="outcome-name">
                        {{betOutcome.name}}
                        <ng-container *ngIf="betTypeShowType.sbvDisplayType == SBVDisplayTypeEnum.SBVInOutcome">
                          <ng-container *ngIf="!bet.useSbvHandicapPipe">{{bet.sbv}}</ng-container>
                          <ng-container *ngIf="bet.useSbvHandicapPipe">{{bet.sbv | handicapSbv}}</ng-container>
                        </ng-container>
                      </span>
                      <span class="odd online-odd"  *ngIf="betOutcome.odd > 1">{{betOutcome.odd | odd}}</span>
                  </div>
                </div>
              </ng-container>
            </ng-container>
            <ng-template #emptyOutcome2>
              <div class="outcome-wrap" *ngIf="bet.sbv">
                <div class="btn small outline-light outcome disabled">
                  <span class="outcome-name">
                    <ng-container *ngIf="  betTypeOutcome.desktopShowType == betTypeOutcomeShowTypeEnum.BTOFullName">
                      {{betTypeOutcome.name}}
                    </ng-container>
                    <ng-container *ngIf="  betTypeOutcome.desktopShowType == betTypeOutcomeShowTypeEnum.BTOShortName">
                     {{betTypeOutcome.shortName}}
                   </ng-container>
                     <ng-container *ngIf="bet.sbv && betTypeShowType.sbvDisplayType == SBVDisplayTypeEnum.SBVInOutcome">
                      <ng-container *ngIf="!bet.useSbvHandicapPipe">{{bet.sbv}}</ng-container>
                      <ng-container *ngIf="bet.useSbvHandicapPipe">{{bet.sbv | handicapSbv}}</ng-container>
                    </ng-container>
                   </span>
                  <i class="icon icon-ex-sm icon-lock"></i>
                </div>
              </div>
            </ng-template>
          </ng-template>
    </ng-template>
  </section>
</section>
